import React from "react";
import "./About.css";

const Portfolio = () => {
  return (
    <div
      className="modal fade"
      tabIndex="-1"
      id="portfolio"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content w-100">
          <div className="modal-header">
            <h5 className="modal-title">Portfolio</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <p className="text">
            Visit my{" "}
            <a href="https://github.com/adrian411997">GitHub profile </a> where
            you can see my others proyects! Thanks for coming!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
